// extracted by mini-css-extract-plugin
module.exports = {"photo":"request-list_photo__EmLyy","name":"request-list_name__3Qwfu","email":"request-list_email__CHxEF","cost":"request-list_cost__2oD3f"};